import { usePathname } from 'next/navigation';

export function useIsOnUsagePage() {
  return usePathname() === '/settings/usage';
}
